<template>
<div class="chapter">
<div class="inner_page">
<blockquote><p class="left"><a id="pvi"></a> <b><span style="font-size: smaller">OTHER BOOKS BY BILL HUFNAGLE</span></b></p></blockquote><blockquote><p class="left"><b>Biker Billy Cooks with Fire</b><br/>
<b>Biker Billy's Freeway-a-Fire Cookbook</b></p></blockquote>
<p class="first"></p>
<p class="follow"><a id="pvii"></a> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?f5597dea